// extracted by mini-css-extract-plugin
export const hero = "blog-module--hero--21zqH";